<template>
    <td class="compare-table__column compare-table__column--product"
    :class="[isSelected ? 'compare-table__column--product-selected-bg': '']">
        <div class="compare-table__currently-selected" v-if="isSelected">
            <strong>CURRENTLY SELECTED</strong>
        </div>
        <div class="compare-table__product-name" v-else><strong>ALTERNATE PRODUCT</strong></div>

        <router-link :to="url" class="compare-table__product">
            <div class="compare-table__product-image image image--type--product">
                <div class="image__body">
                    <img class="image__tag" :src="image" alt="" />
                </div>
            </div>
            <div class="compare-table__product-name">
                {{item}} {{description}}
            </div>
        </router-link>
    </td>
</template>

<script>
export default {
    props : {
        isSelected : {
            type: Boolean,
        },
        item : {
            type: String,
            required: true,
        },
        description : {
            type: String,
        },
        image : {
            type: String,
        },
        url : {
            type: String,
        }
    }
}
</script>